import { RouteConfig } from 'vue-router';
import fetchLoadBalancerName from '@/common/store/modules/lbaas/fetchLoadBalancerName';

const list: Array<RouteConfig> = [
  {
    path: 'load-balancers/:loadBalancerId',
    name: 'computeLoadBalancer',
    redirect: 'load-balancers/:loadBalancerId/pools',
    meta: {
      title: $t => $t('Load balancers'),
      breadcrumb: (_, $t) => Promise.resolve([{
        name: $t('Load balancers'),
        routeName: 'computeLoadBalancers'
      }])
    },
    props: true,
    component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancer'),
    children: [
      {
        path: 'pools',
        name: 'computeLoadBalancerPools',
        component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancerPools'),
        props: true,
        meta: {
          title: $t => $t('Balancing pools'),
          breadcrumb: async (route) => [{ name: await fetchLoadBalancerName(route.params.loadBalancerId) }]
        },
        children: [
          {
            path: 'add-pool',
            name: 'computeLoadBalancersPoolAdd',
            props: true,
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersAddPool'),
            meta: {
              title: $t => $t('Create load balancer pool')
            },
            children: [
              {
                path: 'vms',
                name: 'computeLoadBalancersPoolAddVms',
                component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersPoolVms'),
              },
              {
                path: 'healthmonitor',
                name: 'computeLoadBalancersPoolAddMonitorParams',
                component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersMonitorParams'),
              }
            ]
          },
          {
            path: 'edit/:loadBalancerPoolId/health/:returnRoute?',
            name: 'computeLoadBalancerPoolEditHealth',
            meta: {
              title: $t => $t('Edit health monitor')
            },
            props: true,
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersEditPoolHealth'),
          },
          {
            path: 'edit/:loadBalancerPoolId/members/:returnRoute?',
            name: 'computeLoadBalancerPoolEditVms',
            meta: {
              title: $t => $t('Edit load balancer pool members')
            },
            props: true,
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersPoolEditVms.vue'),
          },
          {
            path: 'edit/:loadBalancerPoolId/allowed-cidrs/:returnRoute?',
            name: 'computeLoadBalancerPoolEditAllowedCidrs',
            meta: {
              title: $t => $t('Edit allowed CIDRs')
            },
            props: true,
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersEditPoolAllowedCidrs'),
          },
          {
            path: 'edit/:loadBalancerPoolId/:returnRoute?',
            name: 'computeLoadBalancerPoolEdit',
            meta: {
              title: $t => $t('Edit load balancer pool')
            },
            props: true,
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersEditPool'),
          },
          {
            path: ':loadBalancerPoolId/:detailsTab(overview|properties|members|allowed-cidrs)?',
            name: 'computeLoadBalancersPoolDetails',
            meta: {
              title: $t => $t('Balancing pool details')
            }
          },
        ]
      },

    ]
  },
];

export default list;
